import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { validateCnpj, validateCPF } from '@/functions/Util';
import * as Util from '@/functions/Util';

export default class PropriedadeValidation extends DefaultValidation {

    constructor(msgs, modulopda) {
        super(msgs);

        if (modulopda && modulopda.detalhe) {
            let detalhe = {};

            modulopda.detalhe.forEach(d => {
                detalhe[d.campo] = d;
            });

            /**
             * Estrutura do objeto detalhe
             *
             * detalhe: {
             *      NOME:       { idmodulopda: 2, campo: "NOME",        obrigainclusao: true, ... },
             *      ENDERECO:   { idmodulopda: 3, campo: "ENDERECO",    obrigainclusao: false, ... }
             * }
             *
             * Feito desse jeito para facilitar o acesso diretamente no objeto (Ex: this.detalhe.ENDERECO.oculta)
             * ao invés de ter que procurar no array toda vez (Ex: this.detalhe.find(e => e.campo == "ENDERECO"))
             */

            this.detalhe = detalhe;
        }
    }

    /**
     * @67517
     * Foi feita a implementação com MODULOPDA
     * A ideia é primeiro verificar se existe o MODULOPDADETALHE dos campos do cadastro
     * Se existir, verificar se não está ocultado. Se não, verificar o obrigainclusao, maxlength e validchars
     * Se não existir, fazer somente a verificação padrão que já existe nos outros cadastros
     *
     * A verificação dos caracteres e max length existe no caso do usuário alterar o HTML da página e remover
     * os limites.
     */

    validate(model, refs) {
        let erroMsg = new Message("alert", "msg-campos-obrigatorios", true);
        let validated = true;

        if (Util.isNull(this.detalhe.NOME) || (!Util.isNull(this.detalhe.NOME) && this.detalhe.NOME.obrigainclusao && !this.detalhe.NOME.oculta)) {
            if (Util.isNull(model.nome)) {
                refs.nomeInput.focusedOut = true;
                validated = false;
            }
        }

        if (Util.isNull(this.detalhe.ENDERECO) || (!Util.isNull(this.detalhe.ENDERECO) && this.detalhe.ENDERECO.obrigainclusao && !this.detalhe.ENDERECO.oculta)) {
            if (Util.isNull(model.cnpjcpf)) {
                refs.enderecoInput.focusedOut = true;
                validated = false;
            }
        }

        if (Util.isNull(this.detalhe.CNPJCPF) || (!Util.isNull(this.detalhe.CNPJCPF) && this.detalhe.CNPJCPF.obrigainclusao && !this.detalhe.CNPJCPF.oculta)) {
            if (Util.isNull(model.cnpjcpf)) {
                refs.cnpjCpfInput.focusedOut = true;
                validated = false;
            }
        }


        // Só realiza as validações abaixo se as de cima não falharem
        if (validated &&
            ((model.cnpjcpf.length != 11 && model.cnpjcpf.length != 14) ||
                (model.cnpjcpf.length == 11 && !validateCPF(model.cnpjcpf)) ||
                (model.cnpjcpf.length == 14 && !validateCnpj(model.cnpjcpf)))
        ) {
            refs.cnpjCpfInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(this.detalhe.IERG) || (!Util.isNull(this.detalhe.IERG) && this.detalhe.IERG.obrigainclusao && !this.detalhe.IERG.oculta)) {
            if (Util.isNull(model.ierg)) {
                refs.rgIeInput.focusedOut = true;
                validated = false;
            }
        }

        if (Util.isNull(model.cliente)) {
            refs.clienteSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(this.detalhe.UNIDADEMEDIDA) || (!Util.isNull(this.detalhe.UNIDADEMEDIDA) && this.detalhe.UNIDADEMEDIDA.obrigainclusao && !this.detalhe.UNIDADEMEDIDA.oculta)) {
            if (Util.isNull(model.unidadeMedida)) {
                refs.unMedidaSelect.focusedOut = true;
                validated = false;
            }
        }

        if (!validated) {
            this.showMessage(erroMsg);
        }

        return validated;
    }

    validateTalhao(model, refs, areas, statusEdicao) {
        let validated = true;

        /* Verificando TALHAO_DESCRICAO */
        if (this.detalhe.TALHAO_DESCRICAO && this.detalhe.TALHAO_DESCRICAO.obrigainclusao && !this.detalhe.TALHAO_DESCRICAO.oculta) {
            if (!model.descricao) {
                this.showMessage(new Message("error", "msg-obrigatorio-descricao", true));
                refs.descricaoInput.focusedOut = true;
                validated = false;
            }

            if (validated && this.detalhe.TALHAO_DESCRICAO.maxlength && model.descricao && model.descricao.length > this.detalhe.TALHAO_DESCRICAO.maxlength) {
                this.showMessage(new Message("error", "msg-descricao-above-max-length", true));
                refs.descricaoInput.focusedOut = true;
                validated = false;
            }

            if (validated && this.detalhe.TALHAO_DESCRICAO.validchars) {
                let rgx = this.getRegexValidchars(this.detalhe.TALHAO_DESCRICAO.validchars);

                if (!rgx.test(model.descricao.toLocaleLowerCase())) {
                    this.showMessage(new Message("error", "msg-descricao-invalid-characters", true));
                    refs.descricaoInput.focusedOut = true;
                    validated = false;
                }
            }

        } else if (!this.detalhe.TALHAO_DESCRICAO) {
            if (!model.descricao) {
                this.showMessage(new Message("error", "msg-obrigatorio-descricao", true));
                refs.descricaoInput.focusedOut = true;
                validated = false;
            }

            if (validated && model.endereco && model.endereco.length > 255) {
                this.showMessage(new Message("error", "msg-descricao-above-max-length", true));
                refs.descricaoInput.focusedOut = true;
                validated = false;
            }
        }

        /* Verificando TALHAO_AREA (select da área) */
        if (this.detalhe.TALHAO_AREA && this.detalhe.TALHAO_AREA.obrigainclusao && !this.detalhe.TALHAO_AREA.oculta) {
            if (this.detalhe.TALHAO_AREA.obrigainclusao && !model.areadesc) {
                this.showMessage(new Message("error", "msg-obrigatorio-area-select", true));
                refs.areaSelect.focusedOut = true;
                validated = false;
            }
        } else if (!this.detalhe.TALHAO_AREA) {
            if (!model.areadesc) {
                this.showMessage(new Message("error", "msg-obrigatorio-area-select", true));
                refs.areaSelect.focusedOut = true;
                validated = false;
            }
        }

        /* Verificando TALHAO_AREATALHAO (valor numérico de área). É tipo DOUBLE no banco, somente verifica se o número é válido. */
        if ((this.detalhe.TALHAO_AREATALHAO && this.detalhe.TALHAO_AREATALHAO.obrigainclusao && !this.detalhe.TALHAO_AREATALHAO.oculta) ||
            (!this.detalhe.TALHAO_AREATALHAO)) {
            let db_area = parseFloat(model.area);

            if (isNaN(db_area) || !db_area || db_area < 0) {
                this.showMessage(new Message("error", "msg-obrigatorio-area-total", true));
                refs.areaInput.focusedOut = true;
                validated = false;
            }
        }

        /* Verificando TALHAO_TIPOTALHAO (select de tipo) */
        if (this.detalhe.TALHAO_TIPOTALHAO && this.detalhe.TALHAO_TIPOTALHAO.obrigainclusao && !this.detalhe.TALHAO_TIPOTALHAO.oculta) {
            if (this.detalhe.TALHAO_TIPOTALHAO.obrigainclusao && !model.tipocadastrotalhao) {
                this.showMessage(new Message("error", "msg-obrigatorio-tipo-cadastro", true));
                refs.tipoInput.focusedOut = true;
                validated = false;
            }
        } else if (!this.detalhe.TALHAO_TIPOTALHAO) {
            if (!model.tipocadastrotalhao) {
                this.showMessage(new Message("error", "msg-obrigatorio-tipo-cadastro", true));
                refs.tipoInput.focusedOut = true;
                validated = false;
            }
        }
        
        // @84514 - Verifica se o talhão que está sendo CRIADO já existe na área selecionada
        if (validated && statusEdicao < 0) {
            let areaSelect
            // @84514 - Seleciona a área que está sendo editada
            for(let area of areas){
                if(area.descricao === model.areadesc.descricao){
                    areaSelect = area
                }
            }
            // @84514 - Verifica os talhões daquela área
            for(let talhao of areaSelect.talhoes){
                if(talhao.descricao === model.descricao){
                    this.showMessage(new Message("error", "msg-talhao-descricao-existente", true));
                    validated = false;
                }
            }
        }

        // @84514 - Verifica se a descrição do talhão que está sendo EDITADO já existe na área selecionada
        if(validated && statusEdicao > -1){
            let areaSelect
            // @84514 - Seleciona a área que está sendo editada
            for(let area of areas){
                if(area.descricao === model.areadesc.descricao){
                    areaSelect = area;
                }
            }
            // @84514 - Verifica os talhões daquela área
            for(let index = 0; areaSelect.talhoes.length-1>=index; index++ ){
                if(index != statusEdicao){
                    if(areaSelect.talhoes[index].descricao === model.descricao){
                        this.showMessage(new Message("error", "msg-talhao-descricao-existente", true));
                            validated = false;
                        }
                    }
                }
        }

        return validated;
    }

}